import { Component, OnDestroy, OnInit } from '@angular/core';
import { MessServiceService } from '@app/shared/common';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-import',
  template: ` <div class="grid">
    <div class="col-12">
      <app-file-upload-v2
        label="Attachment"
        class="w-full"
        [fileList]="fileList"
        [maxFiles]="1"
        [fileType]="['jpg', 'png', 'jpeg', 'webp']"
      >
      </app-file-upload-v2>
    </div>
    <div class="col-12 flex align-items-center justify-content-end">
      <button (click)="onSubmit()" class="main-btn mt-2">
        Import <i class="pi pi-file-import"></i>
      </button>
    </div>
  </div>`,
})
export class ImportComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  fileList: any[] = [];

  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,
    private messService: MessServiceService
  ) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  onSubmit() {
    const fd = new FormData();

    this.subscriptions.push(
      this.config.data['service'].import(fd).subscribe({
        next: (response: any) => {
          this.messService.addError({
            detail: response.message,
          });

          this.ref.close();
        },
        error: (err) => {
          this.messService.addError({
            detail: err.error.message,
          });
        },
      })
    );
  }
}
